import { render } from "./ArticleImages.vue?vue&type=template&id=767b6bcb&scoped=true"
import script from "./ArticleImages.vue?vue&type=script&lang=js"
export * from "./ArticleImages.vue?vue&type=script&lang=js"

import "./ArticleImages.vue?vue&type=style&index=0&id=767b6bcb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767b6bcb"]])

export default __exports__